import { Link } from "react-router-dom";
import { Typography } from "@mui/material";
import { Box } from "@mui/material";
const Footer = () => (
    <Box
      component="footer"
      sx={{
        py: 6,
        textAlign: "center",
      }}
    >
      <Typography variant="h6" gutterBottom>
        KALISUNMARKETING.COM
      </Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        <Link style={{ textDecoration: 'none', color: '#0f8f0f' }} target="_blank" to="https://www.trustpilot.com/review/kalisunmarketing.com">Check Us Out On ★ Trustpilot</Link>
        {/* <a href="" target="_blank">  </a> */}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        Copyright © kalisunmarketing.com 2024. All Rights Reserved.
        <br />
        Results shown are not typical and required hard work & dedication.
      </Typography>
    </Box>
  );
  
export default Footer;